const ComplianceElement = ({
  children,
  config,
  locale,
}: {
  config: any;
  children?: React.ReactNode;
  locale?: string;
}) => {
  console.log('ComplianceElement ======>', config);
  const { action } = config || {};

  if (action === 'hide') {
    return null;
  }

  // if (action === 'redirect') {
  //   window.open(ext.url, ext.target || '_blank');
  // }
  // 其他自定义action

  // const url = ext.url.replace('{locale}', locale);
  // if (action === 'custom') {
  //   // return
  // }

  return children;
};

export default ComplianceElement;
